/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BloodManagementReverseAliases {
  APPLY_FILTER_BUTTON = 'apply-filter-button',
  AUTOCOMPLETE = 'autocomplete',
  AUTOCOMPLETE_REASON_LIST = 'autocomplete-reason-list',
  BLOOD_MANAGEMENT_REVERSE_CONTEXTUAL_BAR = 'blood-management-reverse-contextual-bar',
  BLOOD_MANAGEMENT_REVERSE_LAYOUT = 'blood-management-reverse-layout',
  BLOOD_MANAGEMENT_REVERSE_PANEL = 'blood-management-reverse-panel',
  CLEAR_FILTER_BUTTON = 'clear-filter-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  FETCH = 'fetch',
  FETCH_REASON = 'fetch-reason',
  FIELD = 'field',
  FIELD_REASON = 'field-reason',
  FILTER = 'filter',
  FILTERED_LIST = 'filtered-list',
  FORM_REASON = 'form-reason',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  HEADER_FRAGMENT_REVERSE_TPN = 'header-fragment-reverse-tpn',
  LOADER = 'loader',
  MAPPER = 'mapper',
  MAPPER_REVERSE = 'mapper-reverse',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  PANEL_BUTTON_APPLY = 'panel-button-apply',
  PANEL_BUTTON_CLEAR = 'panel-button-clear',
  PANEL_BUTTONS = 'panel-buttons',
  PANEL_LOADER = 'panel-loader',
  TEXT = 'text',
  TEXT_REVERSE = 'text-reverse',
}
export { BloodManagementReverseAliases };
